import { IncomingMessage } from 'http'
import { Iata } from '@reward-platform/shared-schemas'
import { getWhitelabelOpCoForHost } from '../utils/whitelabel'
import { getPlatformConfigFromCookies } from '../utils/aviosCookies'

export const getOpCoFromRequest = (request: IncomingMessage): Iata => {
  const requestHost = request.headers.host
  const maybeWhitelabelOpCo = getWhitelabelOpCoForHost(requestHost)
  if (maybeWhitelabelOpCo) {
    return maybeWhitelabelOpCo
  }

  const cookies = request.headers.cookie ?? ''
  const { opCo } = getPlatformConfigFromCookies(cookies)

  return opCo
}
